import { render, staticRenderFns } from "./callback.vue?vue&type=template&id=412c12ee&scoped=true"
import script from "./callback.vue?vue&type=script&lang=js"
export * from "./callback.vue?vue&type=script&lang=js"
import style0 from "./callback.vue?vue&type=style&index=0&id=412c12ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412c12ee",
  null
  
)

export default component.exports